import Panel from "./Panel.jsx";
import { formatNumber, formatPercent, formatUsd } from "../lib/utils/formatters.js";

const EXPLANATIONS = {
  usdIndex: "Укрепление USD может давить на золото; слабость USD может поддерживать.",
  realYield: "Снижение реальных доходностей обычно благоприятнее для золота.",
  tenYearYield: "Высокие доходности США повышают альтернативные издержки.",
  fedRate: "Ожидания по ФРС влияют на USD, доходности и риск-аппетит.",
  inflation: "Устойчивая инфляция может поддерживать защитный нарратив золота.",
  sp500: "Risk-on рост акций может снижать спрос на защитные активы.",
  oil: "Нефть влияет косвенно через инфляционные ожидания.",
  btc: "BTC отражает риск-аппетит, но не является прямым драйвером золота.",
};

function Row({ label, value, explanation }) {
  return (
    <div className="grid gap-2 border-b border-white/10 py-3 last:border-b-0 md:grid-cols-[130px_90px_1fr] md:items-start">
      <div className="text-sm font-medium text-slate-200">{label}</div>
      <div className="text-sm font-semibold text-white">{value}</div>
      <p className="text-sm leading-snug text-slate-400">{explanation}</p>
    </div>
  );
}

export default function MacroPanel({ macro = {}, macroScore = 0 }) {
  return (
    <Panel
      title="Макроанализ"
      icon="activity"
      right={<span className="rounded-md bg-cyan/10 px-2 py-1 text-sm font-semibold text-cyan">{macroScore}/100</span>}
    >
      <Row label="Индекс USD" value={formatNumber(macro.usdIndex, 2)} explanation={EXPLANATIONS.usdIndex} />
      <Row label="Реальная доходность" value={formatPercent(macro.realYield, 2)} explanation={EXPLANATIONS.realYield} />
      <Row label="10Y доходность" value={formatPercent(macro.tenYearYield, 2)} explanation={EXPLANATIONS.tenYearYield} />
      <Row label="Ставка ФРС" value={formatPercent(macro.fedRate, 2)} explanation={EXPLANATIONS.fedRate} />
      <Row label="Инфляция" value={formatPercent(macro.inflation, 1)} explanation={EXPLANATIONS.inflation} />
      <Row label="S&P 500" value={formatNumber(macro.sp500, 0)} explanation={EXPLANATIONS.sp500} />
      <Row label="Нефть" value={formatUsd(macro.oil)} explanation={EXPLANATIONS.oil} />
      <Row label="BTC" value={formatUsd(macro.btc, 0)} explanation={EXPLANATIONS.btc} />
      {macro.missingFields?.length ? (
        <p className="mt-3 rounded-md border border-gold/25 bg-gold/10 p-3 text-sm text-goldSoft">
          Недостающие макро-данные заменены: {macro.missingFields.join(", ")}
        </p>
      ) : null}
    </Panel>
  );
}
